var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecrypt0104(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34DAE2;}\n\t.st1{fill:#252A41;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#252A41;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    transform: "translate(-49.696 -117.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    className: "st2",
    d: "M63.09,121.58c0.78-1.07,2-1.74,3.32-1.84c0.11,1.23-0.28,2.45-1.09,3.38 c-0.72,1.01-1.91,1.56-3.14,1.48C62.04,123.51,62.37,122.41,63.09,121.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    className: "st2",
    d: "M62.34,125.8c0.71,0,2.04-0.98,3.76-0.98c1.66-0.07,3.23,0.73,4.14,2.12 c-1.42,0.83-2.3,2.35-2.28,4c0.01,1.87,1.12,3.56,2.85,4.3c0,0-1.99,5.6-4.68,5.6c-1.23,0-2.19-0.83-3.49-0.83 c-1.33,0-2.64,0.86-3.5,0.86c-2.45,0-5.55-5.31-5.55-9.58c0-4.2,2.62-6.4,5.08-6.4C60.27,124.88,61.51,125.8,62.34,125.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecrypt0104);
export default __webpack_public_path__ + "static/media/recrypt_01-04.7eb161f8.svg";
export { ForwardRef as ReactComponent };